export default __webpack_public_path__ + "static/media/icon-security.b6a932b6.svg";